module.exports = __webpack_public_path__ + "img/pro_logo.38c6224d.png";